import { createRouter, createWebHashHistory } from 'vue-router'
import Bttc from '../views/bttc.vue'


const routes = [
  {
    path: '/',
    name: 'Bttc',
    component: Bttc
  },
  {
    path: '/tron',
    name: 'Tron',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/tron.vue')
  },
  {
    path: '/eth',
    name: 'Eth',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/eth.vue')
  },
  {
    path: '/bsc',
    name: 'Bsc',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Bsc.vue')
  },
  {
    path: '/info',
    name: 'Info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Info.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
